export default "__VITE_ASSET__B_K_KbkA__"